var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.633 4.8L22.6878 0.8848C22.5559 0.619071 22.3531 0.395555 22.1022 0.239284C21.8513 0.083013 21.5621 0.000158638 21.267 0H7.33904C7.04398 0.000158638 6.7548 0.083013 6.50386 0.239284C6.25293 0.395555 6.05017 0.619071 5.91828 0.8848L3.97306 4.8H0V8H28.6061V4.8H24.633ZM5.93417 30.6272C6.047 31.4144 6.71766 32 7.50909 32H21.0986C21.481 32.0001 21.8506 31.8613 22.1396 31.6091C22.4286 31.3569 22.6176 31.0083 22.6719 30.6272L25.4276 11.2H3.17845L5.93417 30.6272ZM20.6599 16L19.5252 24H9.08083L7.94613 16H20.6599Z",
    fill: "#F74542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.9192821ee64e6540225e604e27b95d0e.svg";
export { ForwardRef as ReactComponent };